import { z } from "zod";

import { isClosingTimeRequestStartDateAllowed } from "@/utils/closingTimeRequestDateRules";
import {
  compareDateOnly,
  isValidDateOnly,
} from "@/utils/closingTimes/berlinDateOnly";

type Translate = (key: string) => string;

export const createClosingTimeFormSchema = (t: Translate) =>
  z
    .object({
      editor: z
        .string()
        .min(1, t("closeTimes.form.editorNameIsNeeded"))
        .refine((value) => !/\d/.test(value), {
          error: t("closeTimes.form.editorNameCannotContainNumbers"),
        }),
      closingNotice: z
        .string()
        .min(1, t("closeTimes.form.closingNoticeIsNeeded")),
      dateFrom: z
        .string()
        .min(1, t("closeTimes.form.dateFromIsNeeded"))
        .refine(
          (value) => !value || isClosingTimeRequestStartDateAllowed(value),
          {
            message: t("closeTimes.form.dateFromMustBeAfterToday"),
          },
        ),
      dateTo: z.string().min(1, t("closeTimes.form.dateToIsNeeded")),
      scopeOrClassId: z.string().min(1, t("closeTimes.form.scopeIsNeeded")),
    })
    .refine(
      (data) => {
        if (!data.dateFrom || !data.dateTo) {
          return true;
        }

        return (
          isValidDateOnly(data.dateTo) &&
          (compareDateOnly(data.dateTo, data.dateFrom) ?? -1) >= 0
        );
      },
      {
        message: t("closeTimes.form.dateToMustBeAfterDateFrom"),
        path: ["dateTo"],
      },
    );

export type ClosingTimeFormValues = z.infer<
  ReturnType<typeof createClosingTimeFormSchema>
>;
